import * as React from "react"
import { LinkButton, ThemeCss } from "gatsby-interface"
import { OrganizationPermissions } from "@modules/organization/permissions"
import { useTracker, SegmentEventType } from "@modules/analytics"
import { getPathToUpgradeToProfessional } from "@modules/organization/shared/utils"
import { useIsUpgradablePlan } from "../hooks/useIsUpgradablePlan"
import { useIsBillingFormScreen } from "../hooks/useIsBillingFormScreen"
import { useOrganizationInfo } from "./UserOrganizationsHeader.helpers"

/* styles */
const upgradeCss: ThemeCss = () => ({
  alignSelf: `center`,
})

export default function UpgradeLink() {
  const { selectedOrganizationId: organizationId } = useOrganizationInfo()
  const { trackSegment, trackAction } = useTracker()
  const pathToBillingForm =
    organizationId && getPathToUpgradeToProfessional(organizationId)

  const isUpgradablePlan = useIsUpgradablePlan(organizationId)
  const isBillingFormScreen = useIsBillingFormScreen()
  const isUpgradeBtnVisible = !isBillingFormScreen && isUpgradablePlan

  return isUpgradeBtnVisible && pathToBillingForm ? (
    <OrganizationPermissions
      id={organizationId}
      resource="billing"
      action="edit"
    >
      <LinkButton
        to={pathToBillingForm}
        size="M"
        css={upgradeCss}
        onClick={() => {
          trackAction({
            eventType: `TRACK_EVENT`,
            name: `Upgrade button clicked`,
            uiSource: `Dashboard header`,
          })
          trackSegment({
            type: SegmentEventType.Track,
            event: `Upgrade button clicked`,
            properties: {
              location: `Dashboard header`,
            },
          })
        }}
      >
        Upgrade
      </LinkButton>
    </OrganizationPermissions>
  ) : null
}
